/** @format */

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DbService } from './db.service';
import { take } from 'rxjs';

const APP_ID = '0b93c410-fc12-45e4-a041-338bef115650';
const ANDROID_CHANNEL_ID = 'f08063ec-3bfa-491e-8c2e-9856ea4c1709';

@Injectable({
  providedIn: 'root',
})
export class PushService {
  constructor(private httpClient: HttpClient, private db: DbService) {}

  sendPush(pushIds: Array<string>, title: string, message: string, data?: any) {
    return new Promise((resolve, reject) => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json; charset=utf-8',
        }),
      };
      let payload = {
        app_id: APP_ID,
        // TODO 프로젝트를 나눈 후 위의 앱 이름을 맞춰서 title 변경하기
        headings: { en: title || '더 미션' },
        contents: { en: message },
        data,
        include_player_ids: pushIds,
        android_channel_id: ANDROID_CHANNEL_ID,
      };
      if (pushIds.length > 0) {
        this.httpClient.post('https://onesignal.com/api/v1/notifications', payload, httpOptions).subscribe(
          new_data => {
            resolve(new_data);
          },
          error => {
            reject(error);
          }
        );
      }
    });
  }

  // 회원에게 push와 알림 보내기
  memberPush(obj, uuid) {
    this.db
      .collection$(`members`, ref =>
        ref.where('exitSwitch', '==', false).where('suspendSwitch', '==', false).where('pushSwitch', '==', true).where('uuid', '==', uuid)
      )
      .pipe(take(1))
      .subscribe(async (datas: any[]) => {
        if (datas && datas.length > 0) {
          for await (let ele of datas) {
            if (ele.pushId.length > 0) {
              this.sendPush(ele.pushId, obj.title, obj.content, {
                type: obj.type,
                refId: obj.refId,
                uuid: uuid,
                url: '/tabs/alarm',
              });
            }
          }
        }
      });
  }
}
